import React from "react";
import LightCard from "../../../../../../../../components/card/LightCard";
import RedHeader from "../../../../../../../../components/ui/RedBgTitleHeader";
import styled from "styled-components";
import {summary_cost} from "./utility";


const TotalPriceStyle = styled.p`
	font-size: 1.5rem;
	font-weight: bold;
	width: 100%;
	@media (max-width: 575px) {
		font-size: 1.8rem;
	}
`;

// Events musicians costs
const TotalEventsCosts = ({sumEvents, t}) => {

    return (<>
        <LightCard classNames='mb-3 mt-3'>
            <RedHeader title={t("events.summary.event_mus_costs_title")} />
            <div className='row px-2'>
                <div className='col-sm-3 txtCenter'>
                    <p>
                        <u>{t("rates.clients_costs")}</u>
                    </p>
                    <TotalPriceStyle>
                        {sumEvents.client_cost} €
                    </TotalPriceStyle>
                </div>
                <div className='col-sm-3 txtCenter'>
                    <p>
                        <u>{t("rates.estros_costs")}</u>
                    </p>
                    <TotalPriceStyle>{sumEvents.estro_cost} €</TotalPriceStyle>
                </div>
                <div className='col-sm-3 txtCenter'>
                    <p>
                        <u>{t("rates.estro_grant")}</u>
                    </p>
                    <TotalPriceStyle>
                        {sumEvents.grant_cost} €
                    </TotalPriceStyle>
                </div>
                <div className='col-sm-3 txtCenter'>
                    <p>
                        <u>{t("rates.total_costs")}</u>
                    </p>
                    <TotalPriceStyle>{sumEvents.total} €</TotalPriceStyle>
                </div>
            </div>
        </LightCard>
    </>)
}

export default TotalEventsCosts
